import React from 'react';
import {
    Picker,
    TextInput,
    View
} from 'react-native';

import App from "../../../../../App";
import {LanguageManager, Managers, TranslationManager} from "@levelapp/softfabric";
import {TranslationView} from "@levelapp/softfabric-ui";
import {styles} from "./InvestFlowFormViewStyle"
import {UserElement} from "../../InvestFlowView";
import Project from "../../../../../Common/DTO/Project";

interface InvestFlowFormViewProps {
    amountStep: number;
    amount: number;
    setAmount: (value: number) => void;
    selectedUser: UserElement | null;
    setSelectedUser: (value: UserElement | null) => void;
    users: UserElement[];
    project: Project;
}

export const InvestFlowFormView = ({
                                       amountStep,
                                       amount,
                                       setAmount,
                                       selectedUser,
                                       setSelectedUser,
                                       users,
                                       project
                                   }: InvestFlowFormViewProps) => {


    const translationManager: TranslationManager = App.current.resolve<TranslationManager>(Managers.TRANSLATION_MANAGER);
    const languageManager: LanguageManager = App.current.resolve<LanguageManager>(Managers.LANGUAGE_MANAGER);

    const onAmountChange = (value: number) => {
        if (value < 0) return;
        setAmount(value);
    };

    function fetchUser(userName: string) {
        const userFound = users.find(x => x.name === userName);
        if (!userFound) return;
        setSelectedUser(userFound);
    }

    return (
        <>
            <View style={[styles.textInputContainer]}>
                <TranslationView style={[styles.subTitle]}>investflow.form.label.amount</TranslationView>
                <TextInput
                    style={[styles.input]}
                    keyboardType="numeric"
                    placeholder={translationManager.translate("investflow.input.placeholder.amount", languageManager.language)}
                    value={amount.toString()}
                    onChangeText={(value) => {
                        onAmountChange(parseInt(value));
                    }}
                    onKeyPress={({nativeEvent}) => {
                        // +1 and -1 because y default it adds 1 or removes 1 to the amount
                        if (nativeEvent.key === 'ArrowUp') {
                            onAmountChange(amount + amountStep - 1);
                        } else if (nativeEvent.key === 'ArrowDown') {
                            onAmountChange(amount - amountStep + 1);
                        }
                    }}
                />
            </View>
            {project && users.length > 0 && users[0].name != 'null null' && (
                <View style={[styles.selectInputContainer]}>
                    <TranslationView style={[styles.subTitle]}>investflow.form.label.user</TranslationView>
                    <Picker
                        selectedValue={selectedUser?.name}
                        style={[styles.selectInput, styles.input]}
                        onValueChange={(user: string) => fetchUser(user)}
                    >
                    {users.length === 0 ? (
                        <Picker.Item key="loading"
                                     label={translationManager.translate("investflow.form.loading", languageManager.language)}
                                     value={translationManager.translate("investflow.form.loading", languageManager.language)}/>
                    ) : (
                        users.map(user => (
                            <Picker.Item key={user.id} label={user.name} value={user.name}/>
                        ))
                    )}
                </Picker>
            </View>
            )}
        </>
    );
}

export default InvestFlowFormView;